export default __webpack_public_path__ + "static/media/34.40562633.jpg";